export default __webpack_public_path__ + "static/media/review1.5f730e33.jpg";